import { useMatch, useParams } from 'react-router-dom';

import { useConnectionNavigation } from 'pages/Connections/ConnectionDetailsPage/contexts/ConnectionNavigationContext';

import { ConnectionsTestSlideOver } from './components/ConnectionsTestSlideOver/ConnectionsTestSlideOver';
import { ConnectionsTransactionErrorSlideOver } from './components/ConnectionsTransactionErrorSlideOver/ConnectionsTransactionErrorSlideOver';
import { GoLiveSlideOver } from './components/GoLiveSlideOver/GoLiveSlideOver';
import { TaskSlideOver } from './components/TaskSlideOver/TaskSlideOver';
import { TestMessageDetails } from './components/TestMessageDetails/TestMessageDetails';

export const RelationshipDetailsSlideOvers = () => {
  const { relationshipId } = useParams<{ partnerId: string; relationshipId: string }>();
  const { getRoute } = useConnectionNavigation();

  const isTestRoute = Boolean(useMatch(getRoute('testRelationship')));
  const isSeeErrorRoute = Boolean(useMatch(getRoute('testRelationshipTransactionError')));
  const isSeeTestMessageDetails = Boolean(useMatch(getRoute('testRelationshipMessageDetails')));
  const isGoLiveRoute = Boolean(useMatch(getRoute('goLiveRelationship')));
  const isTaskRoute = Boolean(useMatch(getRoute('taskDetails')));

  const testSlideOpen = isTestRoute || isSeeErrorRoute || isSeeTestMessageDetails;

  if (!relationshipId) {
    return null;
  }

  return (
    <>
      <ConnectionsTestSlideOver open={testSlideOpen} />
      <ConnectionsTransactionErrorSlideOver open={isSeeErrorRoute} />
      <TestMessageDetails open={isSeeTestMessageDetails} />
      <GoLiveSlideOver open={isGoLiveRoute} />
      <TaskSlideOver open={isTaskRoute} />
    </>
  );
};
